import { render, staticRenderFns } from "./OrganizationSecurityRoleList.vue?vue&type=template&id=2cb38a78&"
import script from "./OrganizationSecurityRoleList.vue?vue&type=script&lang=js&"
export * from "./OrganizationSecurityRoleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports